import { NgModule } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { EditorModule } from 'primeng/editor';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { KeyFilterModule } from 'primeng/keyfilter';
import { ListboxModule } from 'primeng/listbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PaginatorModule } from 'primeng/paginator';
import { PasswordModule } from 'primeng/password';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RippleModule } from 'primeng/ripple';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SkeletonModule } from 'primeng/skeleton';
import { SliderModule } from 'primeng/slider';
import { SpeedDialModule } from 'primeng/speeddial';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { TimelineModule } from 'primeng/timeline';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { DataViewModule } from 'primeng/dataview';
import { BadgeModule } from 'primeng/badge';

@NgModule({
  providers: [MessageService, ConfirmationService],
  exports: [
    TableModule,
    ButtonModule,
    CardModule,
    DropdownModule,
    InputTextModule,
    RippleModule,
    SliderModule,
    TooltipModule,
    MultiSelectModule,
    PaginatorModule,
    SplitButtonModule,
    SpeedDialModule,
    InputNumberModule,
    InputSwitchModule,
    SelectButtonModule,
    SkeletonModule,
    TabViewModule,
    TimelineModule,
    EditorModule,
    AccordionModule,
    PasswordModule,
    ToolbarModule,
    OverlayPanelModule,
    TextareaModule,
    CheckboxModule,
    BreadcrumbModule,
    CalendarModule,
    RadioButtonModule,
    DialogModule,
    ConfirmPopupModule,
    TieredMenuModule,
    ListboxModule,
    ChartModule,
    DividerModule,
    KeyFilterModule,
    DataViewModule,
    BadgeModule,
  ],
})
export class PrimengModule {}
